import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import _02_45auth_45global from "/app/middleware/02.auth.global.ts";
export const globalMiddleware = [
  validate,
  _02_45auth_45global
]
export const namedMiddleware = {}